<template>
  <div :class="{ 'vs-has-eyebrow': eyebrow == 'true' }">
    <label
      v-if="label"
      class="vs-label"
      :class="{
        'vs-label-eyebrow': eyebrow == 'true',
        'vs-has-focus': inputElFocus,
      }"
      :for="'input_' + id"
    >
      {{ label }}
    </label>
    <div
      class="vs-input-group"
      :class="{ 'vs-eyebrow-group': eyebrow == 'true' }"
    >
      <input
        :id="'input_' + id"
        ref="input"
        v-model.trim="inputValue"
        class="vs-input"
        :class="{ 'vs-error': showError && !valid }"
        :type="type"
        :maxlength="maxLength"
        :placeholder="placeholder"
        :aria-required="showError && !valid"
        :aria-invalid="showError && !valid"
        :aria-describedby="showError && !valid ? inputAllyAlert : ''"
        @blur="onblur_input()"
        @focus="onfocus_input()"
        @focusin="onfocusin_input()"
        @keyup="onkeyup_input($event)"
      >
      <InlineAlert
        v-if="showError && !valid && errorMessage"
        :id="inputAllyAlert"
        :message="errorMessage"
      />
    </div>
  </div>
</template>

<script>
import InlineAlert from '../../inlineAlert/InlineAlert.vue';
import { generateId } from '@/helpers/generate-id';

export default {
  name: 'VsInput',
  expose: ['resetValue'],
  props: {
    id: { type: String, default: generateId().toString() },
    label: { type: String, default: null },
    eyebrow: { type: String, default: '' },
    value: { type: String, default: null },
    errorMessage: { type: String, default: null },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    validators: { type: Array, default: null },
    maxLength: { type: String, default: '' },
  },
  components: {
    InlineAlert,
  },
  data() {
    return {
      inputEl: null,
      inputElFocus: false,
      inputAllyAlert: 'input_alert_' + this.id,
      showError: false,
      valid: true,
      defaultValue: '',
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    inputValue(value) {
      this.handleChange(value);
    },
  },
  mounted() {
    this.inputEl = this.$refs.input;
  },
  created() {
    this.defaultValue = this.value;
    this.handleChange(this.value);
  },
  methods: {
    onblur_input() {
      this.showError = true;
      this.inputElFocus = !!this.inputEl.value;
      this.$emit('onblur');
    },
    onfocus_input() {
      this.inputElFocus = true;
      this.$emit('onfocus');
    },
    onfocusin_input() {
      this.$emit('onfocusin');
    },
    onkeyup_input(e) {
      this.$emit('onKeyup', e);
    },
    checkValidations(value) {
      if (!this.validators) {
        this.valid = true;
        return;
      }
      let result = true;

      this.validators.forEach((validator) => {
        if (!validator(value)) {
          result = false;
        }
      });

      this.valid = result;
    },
    handleChange(value) {
      this.checkValidations(value);
      this.$emit('onChange');
    },
    resetValue() {
      this.inputValue = this.defaultValue;
      this.showError = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/accessibility';
@import '@/styles/core/types/types';
@import '@/styles/label';
@import '@/styles/input';
</style>
